/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Notification Urgent Icon component.
 *
 * ! NOTE: This Icon defines non-standard sizes within the DLS.
 *   https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/00_DLS_Foundation?node-id=1%3A172
 */
/* Example
* import {NotificationUrgentIcon} from '@ion/dls/src/icons/NotificationUrgentIcon';
*
*  <NotificationUrgentIcon size={IconSize.large}
*   color={color} />
*/
export const NotificationUrgentIcon = (
  {color, size, ...props}: IconProps
) => {
  const {iconSize = 22, iconColor = 20} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 22 20' fill='none' {...props}>
      <path d='M11.535 1.753a.5.5 0 00-.867 0L1.431 17.815a.5.5 0 00.433.749h18.483a.5.5 0 00.434-.75l-9.246-16.06zM11.1 7.101v5.861M11.1 14.018v1.62'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10} />
    </svg>
  );
};
